import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=6475f920&"
import script from "./EditGroup.vue?vue&type=script&lang=ts&"
export * from "./EditGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports